export default class ChargeIndividual {
    // Unique identifier for the voucher
    id: number;
    personType: string;
    clientNumber: number;
    clientName: string;
    clientCity: string;
    clientState: string;
    lmNo: number;
    firstName: string;
    lastName: string;
    creditCardDetailId: number;
    voucherAccountId: number;
}



// WEBPACK FOOTER //
// ./src/models/AP/ChargeIndividual.ts